import FormInput from "../UI/Modal/FormInput/FormInput"
import LoadingCircleSpinner from "../../utils/LoadingCircleSpinner"

const LoginForm = ({loading, values, handleChanges, errors, submitForm, showRegister }) =>{

    return(
        <form className='loginForm'>
            {loading && 
                <div className='loadingBackground'>
                    <LoadingCircleSpinner/>
                </div>
            }

            <div className='welcome-text'>
                <div>The First Step to order your food is to login</div>
                <div id="login-text"> Login to FreshOrder </div>
            </div>


            <div className='demo-accounts'>
                <h3> Demo Accounts</h3>
                <div className='accounts-container'>
                    <div className='info'>
                        <h3>Client</h3>
                        <div>Email: <span> veckov@gmail.com</span></div>
                        <div>Pass: <span> veckov</span></div>
                    </div>

                      <div className='info'>
                        <h3>Admin</h3>
                        <div>Email: <span>admin@gmail.com</span></div>
                        <div>Pass: <span>admin</span></div>
                    </div>

                </div>
            </div>

            <div className="input-login-container">
                <div className='input-login'>
                    <FormInput 
                        name='email'
                        type='text'
                        values={values}
                        errors={errors}
                        handleChanges={handleChanges}
                        placeholder='Enter email address'
                    />
                </div>

                <div className='input-login'>
                    <FormInput 
                        name='password'
                        type='password'
                        values={values}
                        errors={errors}
                        handleChanges={handleChanges}
                        placeholder='Enter password'
                    />
                </div>

                <div className='login-button-container'>
                    <button onClick={submitForm}>Login in</button>
                </div>
            </div>

            <div id="create-acc-div">
                <div id="text-acc">New Here? <span onClick={showRegister}>Create an account</span></div> 
            </div>
        </form>
    )
}

export default LoginForm